// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"e96cd2cf","397":"c9ff2db9","955":"c6b92502"}[chunkId] + ".css";
};